export enum EnrollPatientCaseInitiator {
    patient = 'patient',
    pharmacy = 'pharmacy',
    provider = 'provider',
}
